export var UserGroupsType;
(function (UserGroupsType) {
    UserGroupsType["BOARD_ACCESS"] = "BoardAccess";
    UserGroupsType["ROOMS_ACCESS"] = "RoomsAccess";
})(UserGroupsType || (UserGroupsType = {}));
